// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"c8c762fb","168":"c8c762fb","1532":"d5e22eba","1889":"77b83bb2","2881":"77b83bb2","7715":"e9949dd9"}[chunkId] + ".chunk.css";
};